import React, { useEffect, useState } from "react";
import MenuAppBar from "./AppBar";
import { CircularProgress, Box, Typography, Stack } from "@mui/material";
import AppDrawer from "./AppDrawer";
import Breadcrumbs from "./Breadcrumbs";
import MobileBottomNav from "./MobileBottomNav";
import { getAuth } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { useDeviceType } from "../Utils/useDeviceType";
import { getRouteConfig } from "./routeConfig";

const AppLayout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [canShow, setCanShow] = useState({ auth: false });
  const { isMobile } = useDeviceType();
  const location = useLocation();

  const navigate = useNavigate();

  // Bottom nav is hidden on sub-pages (forms, detail views)
  const routeInfo = getRouteConfig(location.pathname);
  const showBottomNav = isMobile && !routeInfo?.parent;

  const getUser = async () => {
    setCanShow({ auth: true });
    const auth = await getAuth();
    if (!auth?.currentUser?.uid) {
      navigate("/how-to-use");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getUser();
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
  };

  return (
    <Stack sx={{ minHeight: "100vh", bgcolor: "#f5f5f5", overflow: "hidden", maxWidth: "100%" }}>
      <AppDrawer open={open} toggleDrawer={toggleDrawer} setOpen={setOpen} />
      <MenuAppBar toggleDrawer={toggleDrawer} />
      <Breadcrumbs />
      <Box sx={{ flex: 1, pb: showBottomNav ? "68px" : 0, overflow: "hidden" }}>
        {!canShow.auth ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "60vh",
            }}
          >
            <CircularProgress size={48} thickness={4} sx={{ color: "#1a237e" }} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Loading...
            </Typography>
          </Box>
        ) : (
          children
        )}
      </Box>
      <MobileBottomNav onOpenMenu={() => setOpen(true)} />
    </Stack>
  );
};

export default AppLayout;
